import React from 'react';
import { ISignificanceVariantStats } from '../../../interfaces';
import SignificanceVariantStatsPopover from '../SignificanceVariantStatsPopover';
import SignificanceLiftValue from './SignificanceLiftValue';
import * as SignificanceTableUI from '../SignificanceTableUI';
import { MetricTypeKey } from '../../../../../utils/apollo/graphqlSchema';
import {
  defaultNumberFormatOptions,
  globalFormat,
  isExponential,
} from '../../../../../utils/formatting';

interface IProps {
  variant: ISignificanceVariantStats;
  isLeading: boolean;
  metricTypeKey: MetricTypeKey;
  label: string;
}

const SignificanceTableVariant = ({
  variant,
  isLeading,
  metricTypeKey,
  label,
}: IProps) => {
  return (
    <SignificanceVariantStatsPopover
      variant={variant}
      metricTypeKey={metricTypeKey}
      label={label}
    >
      <SignificanceTableUI.VariantName>
        {variant.variant}
      </SignificanceTableUI.VariantName>
      <div>
        <SignificanceTableUI.Label>Lift:</SignificanceTableUI.Label>
        <SignificanceLiftValue
          relativePerformance={variant.lift}
          isLeading={isLeading}
        />
      </div>
      <div>
        <SignificanceTableUI.Label>
          Lift Confidence Interval:
        </SignificanceTableUI.Label>
        (
        {globalFormat.formatNumber(
          variant.confidenceInterval.lowerBound,
          defaultNumberFormatOptions.percent,
        )}
        ,{' '}
        {globalFormat.formatNumber(
          variant.confidenceInterval.upperBound,
          defaultNumberFormatOptions.percent,
        )}
        )
      </div>
      <div>
        <SignificanceTableUI.Label>Stat Sig:</SignificanceTableUI.Label>
        {variant.statisticalSignificance ? 'True' : 'False'} (P-Value ={' '}
        {globalFormat.formatNumber(
          variant.pValue,
          isExponential(variant.pValue)
            ? defaultNumberFormatOptions.scientific
            : defaultNumberFormatOptions.originDecimalPoint,
        )}
        )
      </div>
      <div>
        <SignificanceTableUI.Label>Sample Size:</SignificanceTableUI.Label>
        {globalFormat.formatNumber(
          variant.sampleSize,
          defaultNumberFormatOptions.originDecimalPoint,
        )}
      </div>
      <div>
        <SignificanceTableUI.Label>Mean:</SignificanceTableUI.Label>
        {globalFormat.formatNumber(
          variant.mean,
          defaultNumberFormatOptions.originDecimalPoint,
        )}
      </div>
    </SignificanceVariantStatsPopover>
  );
};

export default SignificanceTableVariant;
